document.querySelectorAll('.tpt-event-date').forEach((wrapper) => {
	const field = wrapper.querySelector('.tpt-event-date__field');
	const picker = wrapper.querySelector('.tpt-event-date__picker');

	const realInput = document.querySelectorAll('.tpt-event-date__real-input');

	if (!field || !picker || !realInput) return;

	field.addEventListener('click', () => {
		if (picker.showPicker) {
			picker.showPicker();
		} else {
			picker.focus();
			picker.click();
		}
	});

	const updateDateValue = () => {
		const value = picker.value;

		realInput.forEach((inputItem) => {
			inputItem.value = value;
		});
	};

	picker.addEventListener('change', updateDateValue);

	updateDateValue();
});
